
import { useTranslation } from "react-i18next";
import { useFilter } from "../../../../../hooks/filter";
import { removeAllReference } from "../../../../../utils/methods/removedReference";
import { FilterProps } from "../../../../../hooks/filter/typing";
import { InputModel } from "../../../../../utils/types";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Item } from "../../../../../utils/types/generals";
import { Roles, Types } from "../../../../../utils/enums";
import { filesManagerServiceFetch } from "../../../../../utils/constants/callService";
import { returnQuery } from "../../../../../utils/methods/returnQuery";
import { LoadData, UserLoad } from "../components/addUsers/types";
import { getArea, getDepartments, getDivisions, getRoles, getStore, getUserTypes } from "../../../../../utils/methods/geServiceWithItemsFormat";
import { Box } from "@mui/material";
import { useContextState } from "../../../../../hooks/theme";
import { listRoles } from "../../../../../service/roles";


const useInput = ({ setUserSelected, userSelected }: { userSelected: Record<string, boolean>; setUserSelected: Dispatch<SetStateAction<Record<string, boolean>>> }) => {

  const { t } = useTranslation()
  const [allDepartments, setAllDepartments] = useState<Item[]>([])
  const { colors } = useContextState()
  const [dataUsers, setDataUsers] = useState<{
    id: number;
    division: string;
    name: string;
    curp: string;
    roleId: number;
    roleName: string;
    userType: number;
    areaId: number[];
    areaName: string;
    departmentId: number[];
    departmentName: string;
    userTypeDescription: string;
  }[]>([])
  const [inputFilter, setInputFilter] = useState<{ [x: string]: InputModel }>({
    search: {
      label: 'general.search',
      translate: true,
      name: 'search',
      type: 'text',
      value: null,
    },
    role: {
      label: 'general.tags.role',
      translate: true,
      name: 'role',
      type: 'filter-select',
      items: listRoles
        .filter((item) => ![Roles.ADMIN].includes(item.id))
        .map((item) => ({
          label: item.description, // lo que quieres mostrar
          value: item.id,          // el identificador real
        })) as Item[],
      value: null,
    },
    userType: {
      label: 'general.tags.userType',
      translate: true,
      name: 'userType',
      type: 'filter-select',
      items: [],
      value: null,
    },
    area: {
      label: 'general.tags.area',
      translate: true,
      name: 'area',
      type: 'filter-select',
      items: [],
      value: null,
    },
    department: {
      label: 'general.tags.department',
      translate: true,
      name: 'department',
      type: 'filter-select',
      items: [],
      value: null,
    }
  })

  const [input, setInput] = useState<{ [x: string]: InputModel }>({
    search: {
      label: 'general.searchUsers',
      translate: true,
      name: 'search',
      value: null,
    },
    role: {
      label: 'general.tags.role',
      translate: true,
      name: 'role',
      type: 'filter-select',
      items: listRoles
        .filter((item) => ![Roles.ADMIN].includes(item.id))
        .map((item) => ({
          label: item.description, // lo que quieres mostrar
          value: item.id,          // el identificador real
        })) as Item[],
      value: null,
    },
    stores: {
      label: 'general.tags.store',
      translate: true,
      name: 'stores',
      type: 'filter-select',
      items: [],
      value: null,
    },
    division_ids: {
      label: 'general.tags.divisions',
      translate: true,
      name: 'division_ids',
      type: 'filter-select',
      items: [],
      value: null,
    },
    userType: {
      label: 'general.tags.userType',
      translate: true,
      name: 'userType',
      type: 'filter-select',
      items: [],
      value: null,
    },
    area: {
      label: 'general.tags.area',
      translate: true,
      name: 'area',
      type: 'filter-select',
      items: [],
      value: null,
    },
    department: {
      label: 'general.tags.department',
      translate: true,
      name: 'department',
      type: 'filter-select',
      items: [],
      value: null,
    },
    by_hierarchy: {
      label: 'general.tags.usersByHierarchy',
      translate: true,
      name: 'by_hierarchy',
      type: 'switch',
      items: [],
      value: true,
      wrapChildren: ({ children, id }) => {
        return (
          <Box sx={{ '& .MuiTypography-root': { color: colors.color13 } }}>{children}</Box>
        )
      }
    }
  })

  const [inputUser, setInputUser] = useState<{ [x: string]: InputModel }>({
    search: {
      label: 'general.searchUsers',
      translate: true,
      name: 'search',
      value: null,
    },
    role: {
      label: 'general.tags.role',
      translate: true,
      name: 'role',
      type: 'filter-select',
      items: listRoles
        .filter((item) => ![Roles.ADMIN].includes(item.id))
        .map((item) => ({
          label: item.description, // lo que quieres mostrar
          value: item.id,          // el identificador real
        })) as Item[],
      value: null,
    },
    userType: {
      label: 'general.tags.userType',
      translate: true,
      name: 'userType',
      type: 'filter-select',
      items: [],
      value: null,
    },
    by_hierarchy: {
      label: 'general.tags.usersByHierarchy',
      translate: true,
      name: 'by_hierarchy',
      type: 'switch',
      items: [],
      value: true,
      wrapChildren: ({ children, id }) => {
        return (
          <Box sx={{ '& .MuiTypography-root': { color: colors.color13 } }}>{children}</Box>
        )
      }
    }
  })

  const formatFilter = {
    from: "start_date",
    to: 'end_date',
    status: "status_ids",
    role: "role_ids",
    stores: "store_ids",
    userType: "user_type_ids",
    area: "areas_ids",
    department: "departments_ids"
  }

  const externalValidation: FilterProps['externalValidation'] = ({ name, body, setFilterData }) => {
    let copyBody: Record<string, any> = removeAllReference(body)

    if (name === 'area') {
      const { area, department } = copyBody
      const newDepartments = department?.filter((e: any) => area.find((e2: any) => e2.value == e.areaId))
      let arrayChilds: any[] = []

      area?.forEach((e: any) => {
        const id = e.value
        const childs = allDepartments.filter((child) => child.areaId == id)
        arrayChilds.push(...childs)
      })

      setFilterData((prev) => ({
        ...prev,
        department: newDepartments,
      }))

      setInput(prev => ({ ...prev, department: { ...prev.department, items: arrayChilds } }))
      copyBody = {
        ...copyBody,
        department: newDepartments,
      }
    }

    return copyBody
  }

  const externalValidationPermission: FilterProps['externalValidation'] = ({ name, body, setFilterData }) => {
    let copyBody: Record<string, any> = removeAllReference(body)

    if (name === 'area') {
      const { area, department } = copyBody
      const newDepartments = department?.filter((e: any) => area.find((e2: any) => e2.value == e.areaId))
      let arrayChilds: any[] = []

      area?.forEach((e: any) => {
        const id = e.value
        const childs = allDepartments.filter((child) => child.areaId == id)
        arrayChilds.push(...childs)
      })

      setFilterData((prev) => ({
        ...prev,
        department: newDepartments,
      }))

      setInputFilter(prev => ({ ...prev, department: { ...prev.department, items: arrayChilds } }))
      copyBody = {
        ...copyBody,
        department: newDepartments,
      }
    }

    return copyBody
  }

  const [modalLoad, setModalLoad] = useState<{ open: boolean; tmpUsuers?: Record<string, string | number | number[]>[] }>({ open: false })
  const [loadings, setLoadings] = useState({ search: false, load: false, table: false, submit: false, main: false })
  const [snackbar, setSnackbar] = useState<{ open: boolean; type: Types; message: string }>({
    open: false,
    message: '',
    type: Types.SUCCESS,
  })

  const getAllDepartments = async () => {
    const items = await getDepartments()
    setAllDepartments(items)
  }

  const getAllUnits = async () => {
    const { items } = await getStore()
    setInput(prev => ({ ...prev, stores: { ...prev.stores, items } }))
  }

  const getAllUserTypes = async () => {
    const { items } = await getUserTypes({all: true})
    setInput(prev => ({ ...prev, userType: { ...prev.userType, items } }))
    setInputFilter(prev => ({ ...prev, userType: { ...prev.userType, items } }))
    setInputUser(prev => ({ ...prev, userType: { ...prev.userType, items } }))
  }

  const getAllRoles = async () => {
    const { items } = await getRoles({ skip: [Roles.ADMIN] })
    //setInput(prev => ({ ...prev, role: { ...prev.role, items } }))
    //setInputFilter(prev => ({ ...prev, role: { ...prev.role, items } }))
    //setInputUser(prev => ({ ...prev, role: { ...prev.role, items } }))
  }

  const getAlDivisions = async () => {
    const { items } = await getDivisions()
    setInput(prev => ({ ...prev, division_ids: { ...prev.division_ids, items } }))
  }

  const getAllAreas = async () => {
    const items = await getArea()
    setInput(prev => ({ ...prev, area: { ...prev.area, items: items } }))
    setInputFilter(prev => ({ ...prev, area: { ...prev.area, items: items } }))
  }

  const getData = () => {
    getAllUnits()
    getAllUserTypes()
    getAllRoles()
    getAllAreas()
    getAllDepartments()
    getAlDivisions()
  }

  useEffect(() => {
    getData()
  }, [])

  const createFilter = useFilter({
    formatFilter,
    externalValidation,
    defaultPagination: { pageSize: 500 }
  })

  const userFilter = useFilter({
    formatFilter,
    externalValidation,
    defaultPagination: { pageSize: 500 }
  })

  const permissionFilter = useFilter({
    formatFilter,
    externalValidation: externalValidationPermission,
    defaultPagination: { pageSize: 500 }
  })

  const searchUsers = async () => {
    try {
      setLoadings(prev => ({ ...prev, search: true }))
      const response = await filesManagerServiceFetch.getUsersToAddPermissions({ query: returnQuery(createFilter.query, {}) })
      let allUsers: Record<string, string | number | number[]>[] = response?.map(item => ({
        id: item.id.toString(),
        users: item.fullName && item.fullName.trim() !== "" ? item.fullName : "N/A",
        userType: item.userType ?? '',
        division: item.division,
        area: item.area ?? '',
        department: item.department ?? '',
        areaId: item.areasIds
          ? item.areasIds.split(',').map((val: string) => Number(val.trim()))
          : [],
        departmentId: item.departmentsIds
          ? item.departmentsIds.split(',').map((val: string) => Number(val.trim()))
          : [],
        role: item.role ?? '',
        curp: item.curp ?? '',
        roleId: item.roleId,
        userTypeId: item.userTypeId,
      })) ?? []
      if (!!allUsers?.length) {
        setModalLoad(prev => ({ ...prev, open: true, tmpUsuers: allUsers }))
      } else {
        setModalLoad(prev => ({ ...prev, open: true, tmpUsuers: [] }))
        setSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
      }
    } catch (e) {
      setModalLoad(prev => ({ ...prev, open: true, tmpUsuers: [] }))
      setSnackbar(prev => ({ ...prev, open: true, message: t("general.messages.errors.noUsers"), type: Types.ERROR }))
    }
    finally {
      setLoadings(prev => ({ ...prev, search: false }))
    }
  }

  const cancelSearchUsers = () => {
    createFilter.cleanFilter()
    setModalLoad(prev => ({ ...prev, open: false, tmpUsuers: [] }))
    setLoadings(prev => ({ ...prev, search: false }))
  }

  const loadUsers: LoadData = (listUsers: UserLoad[], success) => {
    let userJson = { ...userSelected }
    let dataJson = [...dataUsers]
    let amount = 0
    listUsers?.forEach((user: any) => {
      const userId = user.id
      const id = user.id
      const userTypeDescription = user.userType
      const name = user.users
      const curp = user.curp
      const roleId = user.roleId
      const roleName = user.role
      const userType = user.userTypeId
      const areaId = user.areaId
      const areaName = user.area
      const departmentId = user.departmentId
      const departmentName = user.department
      const division = user.division

      if (!userSelected?.[userId]) {
        amount += 1
        userJson = { ...userJson, [userId]: true }
        dataJson.push({
          id,
          userTypeDescription,
          areaId,
          areaName,
          curp,
          departmentId,
          departmentName,
          division,
          name,
          roleId,
          roleName,
          userType,
        });
      }
    })
    setDataUsers(dataJson)
    success({ amountOfUserAdded: amount, loadSuccess: !!amount })
    setUserSelected(userJson)

  }

  const closeSnackbar = () => { setSnackbar(prev => ({ ...prev, open: false })) }

  return {
    input,
    createFilter,
    setDataUsers,
    dataUsers,
    permissionFilter,
    searchUsers,
    cancelSearchUsers,
    modalLoad,
    loadUsers,
    inputFilter,
    inputUser,
    loadings,
    snackbar,
    closeSnackbar,
    setSnackbar,
    userFilter
  }

}

export { useInput }